// Core
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import Button from 'components/commonComponents/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// Styles
import './styles.scss';
import OtpInput from 'react-otp-input';
import { useDispatch } from 'react-redux';
import ResetPassword from '../ResetPassword';
import { saveSession, updateStoredUser } from 'utils/session';
import { useAlert } from 'hooks/useAlert';
import AlertSnackbar from 'components/commonComponents/AlertSnackbar';
import ActionLink from 'components/commonComponents/ActionLink';

const Otp = (props) => {
  const { onClose, open, email, type, value } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [otp, setData] = useState('');
  const [otpTemp, setDataTemp] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { errorAlert, setErrorAlert, showAlert } = useAlert();
  const [resetOpen, setResetOpen] = useState(false);

  const handleOnChange = (value) => {
    setData(value)
  };

  const handleSave = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append('email', email)
    formData.append('otp', otp)
    formData.append('appId', '29')
    setDataTemp(otp)
    const res = type === 'email' ? await fetchData(restAPIs.changeEmail(formData)) : await fetchData(restAPIs.otpVerify(formData));
    if (res.statusCode === 200) {
      showAlert(res.errormessage, 'success');

      if (type === 'email') {
        const localDetails = updateStoredUser({ email });
        dispatch({
          type: 'userDetails',
          value: localDetails
        });
        handleClose();
      }

      if (type === 'signup') {
        let full = { ...value, ...res.user }
        dispatch({
          type: 'userDetails',
          value: full
        });
        saveSession(full, value.sessionToken);
        handleClose();
      }

      if (type === 'login') {
        onClose()
        dispatch({
          type: 'userDetails',
          value: res.user
        });
        saveSession(res.user);
      }
      if (type === 'forgot') {
        setResetOpen(true);
      }
      setData('');

    } else {
      showAlert(res.errormessage, 'error');
    }
    setIsLoading(false);
  };

  const handleClose = (event, reason) => {
    setData('');
    setErrorAlert({})
    if (reason === "backdropClick") {
      console.log(reason);
    } else {
      onClose();
    }
  };

  const handleCloseReset = () => {
    setResetOpen(false);
    onClose();
  };


  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        className='__common_model_class'
        maxWidth={'sm'}
        fullWidth={true}
        disableEscapeKeyDown
      >
        <DialogTitle id="alert-dialog-title">
          OTP
        </DialogTitle>
        <DialogContent>
          <p>An OTP is sent to your email for verification
            <br />Please check your email inbox or spam folders for the OTP email.</p>
          <div className='mt-2'>
            <OtpInput
              value={otp}
              onChange={handleOnChange}
              numInputs={4}
              isInputNum={true}
              className='_custom_input'
            />
          </div>
        </DialogContent>
        <DialogActions>
          <div className='d-flex align-items-center' style={{ margin: '15px' }}>
            <ActionLink onClick={() => handleClose(false)} style={{ cursor: 'pointer', margin: '0 10px' }}>{t('cancel')}</ActionLink>
            <Button
              withLoader
              loading={isLoading}
              disabled={isLoading || otp.length !== 4}
              handleOnClick={handleSave}
              label={t('submit')}
            />
          </div>
        </DialogActions>
        <AlertSnackbar alert={errorAlert} />
        <ResetPassword onClose={handleCloseReset} open={resetOpen} email={email} otp={otpTemp} />
      </Dialog>
    </>
  );
};

export default Otp;
